import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { SortDescriptor } from "@progress/kendo-data-query";
import appConfig from "../../util/appConfig";
import { getAdminNotificationItemsCount } from "../../store/slices/app";
import {
  GridCellProps,
  GridColumn,
  GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import {
  AdminCheckbox,
  AdminContentWrapper,
  AdminHeader,
  Loader,
  TableGrid,
  TableLastItem,
} from "../../components";
import { getAdminTonneDefekt } from "../../store/slices/tonneDefect";
import { format } from "date-fns";

export const statuses: { [key: string]: string } = {
  check: "Prüfen",
  accepted: "Fertig",
  declined: "Storniert",
  inWork: appConfig.logo === "calw" ? "Offen" : "In Arbeit",
  error: "Fehler",
  warning: "Warnung",
};

const AdminTonneDefekt = () => {
  const dispatch = useAppDispatch();
  const { isAdminLoaderActive } = useAppSelector((state) => state.admin);
  const { itemsCount, tonneDefektData } = useAppSelector(
    (state) => state.tonneDefekt.admin,
  );

  const [sort, setSort] = useState<Array<SortDescriptor>>([]);
  const [value, setValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [datesChanged, setDatesChanged] = useState({});
  const [status, setStatus] = useState<string[]>([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [allItemsSelected, setAllItemsSelected] = useState(false);

  const onDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end || end === null) {
      setDatesChanged({ updated: true });
    }
  };

  const changeHandler = (val: string) => {
    setValue(val);
  };

  const pageChangeHandler = (page: number) => {
    setPage(page);
  };

  const pageSizeHandler = (size: number) => {
    setPage(1);
    setPageSize(size);
  };

  const changeStatuses = (st: string[]) => {
    setStatus([...st]);
  };

  const setAcceptedStatus = async () => {
    // if (["calw"].includes(appConfig.logo)) {
    // await dispatch(
    //   changeReclamationItemsStatuses({
    //     ids: reclamationData.map((el) => el.id),
    //     status: "accepted",
    //   })
    // );
    await dispatch(getAdminNotificationItemsCount());

    return;
    // }
  };

  const allItemsSelectHandler = () => {
    if (!allItemsSelected) {
      setAllItemsSelected(true);
      const ids = tonneDefektData.map((i) => i.id);
      setSelectedItems([...ids]);
      return;
    }
    if (allItemsSelected) {
      setAllItemsSelected(false);
      setSelectedItems([]);
      return;
    }
  };

  const selectItemHandler = (id: string) => {
    if (selectedItems.includes(id)) {
      const t = selectedItems.filter((i) => i !== id);
      return setSelectedItems([...t]);
    }

    if (!selectedItems.includes(id)) {
      return setSelectedItems((prev) => [...prev, id]);
    }
  };

  const FirstItem = (props: GridCellProps) => {
    return (
      <td
        // className="k-command-cell"
        style={
          {
            // backgroundColor: 'white',
          }
        }
      >
        <AdminCheckbox
          checked={selectedItems.includes(props.dataItem.id)}
          changeHandler={() => {
            selectItemHandler(props.dataItem.id);
          }}
        />
      </td>
    );
  };
  const FirstHeaderItem = (props: GridHeaderCellProps) => {
    return (
      <div
        style={{
          margin: "0",
          padding: "0",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          // border: "none",
          // backgroundColor: "rgba(0, 0, 0, 0.02) !important",
        }}
        // className={style.qwe}
      >
        <AdminCheckbox
          checked={allItemsSelected}
          changeHandler={allItemsSelectHandler}
        />
      </div>
    );
  };

  const generateSelectOptions = (type: string) => {
    switch (type) {
      default: {
        return [
          { label: statuses.accepted, value: "accepted" },
          { label: statuses.inWork, value: "inWork" },
          { label: statuses.declined, value: "declined" },
          { label: statuses.check, value: "check" },
          { label: statuses.warning, value: "warning" },
        ];
      }
    }
  };

  useEffect(() => {
    const abortController = new window.AbortController();
    const signal = abortController.signal;

    dispatch(
      getAdminTonneDefekt({
        signal,
        direction: sort[0]?.dir,
        page,
        pageSize,
        searchValue: value,
        sort: sort[0]?.field,
        startDate: startDate ? new Date(startDate).toUTCString() : startDate,
        endDate: endDate ? new Date(endDate).toUTCString() : endDate,
        status,
        // direction: sort[0]?.dir,
        // page,
        // pageSize,
        // searchValue: value,
        // sort: sort[0]?.field,
        // signal,
        // startDate: startDate ? new Date(startDate).toUTCString() : startDate,
        // endDate: endDate ? new Date(endDate).toUTCString() : endDate,
        // status,
      }),
    );

    return () => {
      if (signal && abortController.abort) {
        abortController.abort();
      }
    };
  }, [sort, page, pageSize, value, datesChanged, status]);

  const selectorOptions = [
    {
      placeholder: "Bitte Status wählen",
      isActive: ["calw"].includes(appConfig.logo),
      defaultValue: undefined,
      selectOptions: generateSelectOptions(appConfig.logo).filter(
        (el) => !status.includes(el.value),
      ),
      value: status.map((el) => {
        return {
          value: el,
          label: statuses[el],
        };
      }),
      onChange: changeStatuses,
    },
  ];

  const generateColumns = (env?: string) => {
    switch (env) {
      case "viersen": {
        return [
          { field: "status", title: "Status" },
          { field: "createdAt", title: "Datum (Meldung)" },
          { field: "kassenzeichen", title: "Kassenzeichen" },
          { field: "place", title: "Ort" },
          { field: "street", title: "Straße" },
          { field: "name", title: "Nachname, Vorname" },
        ];
      }
      default: {
        return [
          { field: "status", title: "Status" },
          { field: "createdAt", title: "Datum (Meldung)" },
          { field: "name", title: "Nachname, Vorname" },
          { field: "street", title: "Straße" },
          // { field: "postCode", title: "PLZ" },
          { field: "place", title: "Ort" },
        ];
      }
    }
  };

  return (
    <div>
      <AdminHeader pageTitle={"Tonne defekt"} hasBtnGroup={false} />
      <AdminContentWrapper>
        <TableGrid
          data={tonneDefektData.map((el) => {
            return {
              ...el,
              street: `${el.street} ${el.homeNumber}${
                el?.hausNrZusatz ? ` ${el?.hausNrZusatz}` : ""
              }`,
              name: `${el.userSurname}, ${el.userName} `,
              createdAt: el.createdAt
                ? format(new Date(el.createdAt), "dd.MM.yyyy, HH:mm")
                : "",
              time: el.createdAt ? format(new Date(el.createdAt), "HH:mm") : "",
              status: el.status ? statuses[el.status] : "",
            };
          })}
          sort={sort}
          sortable={true}
          onSortChange={setSort}
          items={generateColumns(appConfig.logo)}
          searchInputValue={value}
          onSearchInputValueChange={changeHandler}
          withPager={true}
          page={page}
          pageSize={pageSize}
          pageChangeHandler={pageChangeHandler}
          pageSizeHandler={pageSizeHandler}
          itemsCount={itemsCount}
          onDateChange={onDateChange}
          startDate={startDate}
          endDate={endDate}
          withDatePicker
          onExcelExportClickHandler={setAcceptedStatus}
          lastItem={<GridColumn cell={TableLastItem} width="50px" />}
          selectorOptions={selectorOptions}
          firstItem={
            <GridColumn
              cell={FirstItem}
              width="40px"
              headerCell={FirstHeaderItem}
            />
          }
        />
      </AdminContentWrapper>
      {isAdminLoaderActive && <Loader />}
    </div>
  );
};

export default AdminTonneDefekt;
